import { Basic } from "../basic.ts";
import i18next from "i18next";
import styles from './paneltabcontrol.css'
/**
 * @class MSPanelTabControl
 * @extends Basic
 * @classdesc Панель вкладок
 * */

const arrowNext = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 5L6 13L7 13L7 12L8 12L8 11L9 11L9 10L10 10L10 8L9 8L9 7L8 7L8 6L7 6L7 5L6 5Z" fill="#DDDDDB"/></svg>'
const arrowPrev = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5V13H9V12H8V11H7V10H6V8H7V7H8V6H9V5H10Z" fill="#DDDDDB"/></svg>'

export class MSPanelTabControl extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "layout",
            "orientation",
            "currenttab",
            "tabs",
            "headerbackgroundcolor",
            "tabbackgroundcolor",
            "tabfontfamily",
            "tabfontsize",
            "tabtextalign",
            "istabtextitalic",
            "istabtextunderline",
            "istabfontweight",
            "tabcolor",
            "heighttab",
            "widthtab",
            "movetabs",
        ]);
    }
    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <div class="tabs__container tabs__container__row">
                <div class="control_btn previous-arrow">${arrowPrev}</div>
                <div class="row-slider">
                    <div id="tabs" class="tabpanel__header tabheader__row"></div>
                </div>
                <div class="control_btn next-arrow">${arrowNext}</div>
            </div>
            <slot></slot>
        `;
        this.style.display = "flex";
        this.style.flexDirection = "column";
        this.style.boxSizing = "content-box";
        this.style.backgroundColor = "rgb(245,240,245)";
        this._tabs = shadowRoot.getElementById("tabs");
        this._tabsContainer = shadowRoot.querySelector(".tabs__container");
        this._nextBtn = shadowRoot.querySelector('.next-arrow');
        this._previousBtn = shadowRoot.querySelector('.previous-arrow');
        this.layout = 0;
        this.initBtn();
    }

    initBtn() {
        this._nextBtn.addEventListener('click', this.NextTab.bind(this));
        this._previousBtn.addEventListener('click', this.PreviousTab.bind(this));
    }

    NextTab() {
        if (!this._child || !this._nextBtn.classList.contains("active")) {
            return;
        }
        const visibleTabs = Array.from(this._tabButtons).filter(x => this.tabsData.find(y => y.id === x.getAttribute("tabId")).isVisible);
        if (this.layout > 1) {
            const allBtnsHeight = visibleTabs.map(x => x.offsetHeight + 1).reduce((acc, val) => acc + val, 0); // 1 - это margin-bottom
            const averageTabHeight = allBtnsHeight / visibleTabs.length;
            const { translateY } = this.getTranslateXY(this._tabs);
            const newTransformTranslateY = translateY - averageTabHeight;
            const maxAllowedTranslateY = allBtnsHeight - this._tabs.offsetHeight;

            if (Math.abs(newTransformTranslateY) >= maxAllowedTranslateY) {
                this._tabs.style.transform = `translateY(${-maxAllowedTranslateY}px)`;
                this.setNextBtnState(false);
            } else {
                this._tabs.style.transform = `translateY(${newTransformTranslateY}px)`;
                this.setNextBtnState(true);
            }
        } else {
            const allBtnsWidth = visibleTabs.map(x => x.offsetWidth + 1).reduce((acc, val) => acc + val, 0); // 1 - это margin-left
            const averageTabWidth = allBtnsWidth / visibleTabs.length;
            const { translateX } = this.getTranslateXY(this._tabs);
            const newTransformTranslateX = translateX - averageTabWidth;
            const maxAllowedTranslateX = allBtnsWidth - this._tabs.offsetWidth;

            if (Math.abs(newTransformTranslateX) >= maxAllowedTranslateX) {
                this._tabs.style.transform = `translateX(${-maxAllowedTranslateX}px)`;
                this.setNextBtnState(false);
            } else {
                this._tabs.style.transform = `translateX(${newTransformTranslateX}px)`;
                this.setNextBtnState(true);
            }
        }
        this.setPrevBtnState(true);
    }

    PreviousTab() {
        if (!this._child || !this._previousBtn.classList.contains("active")) {
            return;
        }
        const visibleTabs = Array.from(this._tabButtons).filter(x => this.tabsData.find(y => y.id === x.getAttribute("tabId")).isVisible);
        if (this.layout > 1) {
            const allBtnsHeight = visibleTabs.map(x => x.offsetHeight + 1).reduce((acc, val) => acc + val, 0); // 1 - это margin-bottom
            const averageTabHeight = allBtnsHeight / visibleTabs.length;
            const { translateY } = this.getTranslateXY(this._tabs);
            const newTransformTranslateY = translateY + averageTabHeight;
            if (newTransformTranslateY < 0) {
                this._tabs.style.transform = `translateY(${newTransformTranslateY}px)`;
                this.setPrevBtnState(true);
            } else {
                this._tabs.style.transform = 'translateY(0)';
                this.setPrevBtnState(false);
            }
        } else {
            const allBtnsWidth = visibleTabs.map(x => x.offsetWidth + 1).reduce((acc, val) => acc + val, 0); // 1 - это margin-left
            const averageTabWidth = allBtnsWidth / visibleTabs.length;
            const { translateX } = this.getTranslateXY(this._tabs);
            const newTransformTranslateX = translateX + averageTabWidth;
            if (newTransformTranslateX < 0) {
                this._tabs.style.transform = `translateX(${newTransformTranslateX}px)`;
                this.setPrevBtnState(true);
            } else {
                this._tabs.style.transform = 'translateX(0)';
                this.setPrevBtnState(false);
            }
        }
        this.setNextBtnState(true);
    }

    getTranslateXY(element) {
        const style = window.getComputedStyle(element);
        const matrix = new DOMMatrixReadOnly(style.transform);
        return {
            translateX: matrix.m41,
            translateY: matrix.m42
        }
    }

    setNextBtnState(isActive) {
        this._nextBtn.classList.toggle("active", isActive);
    }

    setPrevBtnState(isActive) {
        this._previousBtn.classList.toggle("active", isActive);
    }

    getAllBtnWidth() {
        const visibleTabs = Array.from(this._tabButtons).filter(x => this.tabsData.find(y => y.id === x.getAttribute("tabId")).isVisible);
        return visibleTabs.map(x => x.offsetWidth + 1).reduce((acc, val) => acc + val, 0); // 1 - это margin-left
    }

    updateArrowsState(newTransformTranslateX) {
        this.setPrevBtnState(newTransformTranslateX !== 0);
        const maxAllowedTranslateX = this.getAllBtnWidth() - this._tabs.offsetWidth;
        this.setNextBtnState(Math.abs(newTransformTranslateX) !== maxAllowedTranslateX);
    }

    refreshArrowState() {
        const isArrowVisible = this.updateArrowsVisibility();
        if (isArrowVisible) {
            this.setPrevBtnState(false);
            this.setNextBtnState(true);
        }
        this._tabs.style.transform = "translateX(0)";
    }

    _genTabs() {
        this._tabs.innerHTML = "";
        this._child = [];
        this._childBtn = [];
        let isFirstVisibleTab = false;
        this.tabsData = [];

        for (let index = 0; index < this._tabsDef.length; index++) {
            const { id, name } = this._tabsDef[index];
            const tabContent = this._loadTab(id);
            const tabNumber = index + 1;
            this.tabsData.push({
                id,
                name,
                isVisible: !!tabContent,
                tabNumber
            })
            if (!tabContent) {
                continue;
            }

            const btn = this.createTabBtn(name, id);
            this._tabs.appendChild(btn);

            if (!isFirstVisibleTab) {
                isFirstVisibleTab = true;
                this.currenttab = tabNumber;
            } else {
                tabContent.style.display = "none";
            }
        }
        this._tabButtons = this._tabs.querySelectorAll(".tabpanel__btn_black");
        this.updateArrowsVisibility();
    }

    updateArrowsVisibility() {
        let isArrowVisible;
        if (this.layout > 1) {
            const totalTabsHeight = Array.from(this._tabButtons).reduce((acc, tab) => acc + tab.offsetHeight + 1, 0); // 1 - это margin-bottom
            const containerHeight = this._tabsContainer.offsetHeight;
            isArrowVisible = totalTabsHeight >= containerHeight;
        } else {
            const totalTabsWidth = Array.from(this._tabButtons).reduce((acc, tab) => acc + tab.offsetWidth + 1, 0); // 1 - это margin-left
            const containerWidth = this._tabsContainer.offsetWidth;
            isArrowVisible = totalTabsWidth >= containerWidth;
        }
        const displayStyle = isArrowVisible ? 'flex' : 'none';
        this._nextBtn.style.display = displayStyle;
        this._previousBtn.style.display = displayStyle;
        if (isArrowVisible) {
            this.setPrevBtnState(false);
            this.setNextBtnState(true);
        }
        return isArrowVisible;
    }

    _loadTab(id) {
        const isVisible = document
            .querySelector(`template#t_${id}`)
            .content.children[0].getAttribute("isvisible");

        const isTabHidden = isVisible !== null && !this._toBool(isVisible);
        if (isTabHidden) {
            return "";
        }
        const template = document
            .querySelector(`template#t_${id}`)
            .content.children[0].cloneNode(true);
        template.style.flexShrink = 0;
        template.style.position = "relative";
        template.x = 0;
        template.y = 0;
        this.appendChild(template);
        this._child.push(template);
        template.setAttribute("height", "100%");
        template.setAttribute("width", "100%");
        return template;
    }

    _onTabClick(e) {
        const tabId = e.currentTarget.getAttribute("tabId");
        this.SelectTab(this.tabsData.find(x => x.id === tabId).tabNumber, false);
    }

    createTabBtn(name, tabId) {
        const btn = document.createElement("button");
        this._childBtn.push(btn);
        btn.classList.add("tabpanel__btn_black");
        btn.setAttribute("tabId", tabId);
        btn.innerHTML = name;
        btn.onclick = this._onTabClick.bind(this);
        return btn;
    }

    /**
     * переключить табулятор на закладку по индексу
     * @param {*} newIndex
     * @memberof MSPanelTabControl
     */
    SelectTab(tabNumber, ignorePerm = true) {
        if (this.hasWarning(tabNumber)) {
            return;
        }

        this.SetParameter("currenttab", tabNumber, ignorePerm, null, null, "", {
            beforeCallbackFn: () => {
                this._interaction = true;
            },
            afterCallbackFn: () => {
                this._interaction = false;

                const { id: newTabId } = this.tabsData.find(x => x.tabNumber === tabNumber);
                const newActiveBtn = this._childBtn.find(x => x.getAttribute("tabId") === newTabId);
                const prevActiveBtn = this._childBtn.find(x => x.classList.contains("active"));
                if (prevActiveBtn) {
                    // Предыдущей активной вкладки не будет, если все вкладки скрыты
                    if (newActiveBtn === prevActiveBtn) {
                        // Новая вкладка может быть уже открыта, только если prevActiveBtn определено
                        // Это условие помогает выйти из рекурсии
                        return;
                    }
                    prevActiveBtn.classList.remove("active");
                    const prevActiveTabContent = this._child.find(x => x.id === prevActiveBtn.getAttribute("tabId"));
                    prevActiveTabContent.style.display = "none";
                }

                newActiveBtn.classList.add("active");
                const newActiveTabContent = this._child.find(x => x.id === newActiveBtn.getAttribute("tabId"));
                newActiveTabContent.style.display = "flex";

                // Вызываем Event tab-open вкладка открыта
                const controls = ['ms-map', 'ms-trend', 'ms-trendds', "ms-chart"];
                controls.forEach((control) => {
                    const controlElements = newActiveTabContent.querySelectorAll(control);
                    if (controlElements.length) {
                        controlElements.forEach(el => el.dispatchEvent(new Event('tab-open')))
                    }
                })

                this._currenttab = +tabNumber;
            },
        });
    }

    hasWarning(tabNumber) {
        const newTab = this.tabsData.find(x => x.tabNumber === tabNumber);
        if (!newTab) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: String.format(i18next.t("paneltabcontrol_tab_not_found_title"), tabNumber),
                text: String.format(i18next.t("paneltabcontrol_tab_not_found_text"), this._elname),
            });
            return true;
        }
        if (!newTab.isVisible) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: String.format(i18next.t("paneltabcontrol_tab_is_hidden_title"), tabNumber),
                text: String.format(i18next.t("paneltabcontrol_tab_is_hidden_text"), this._elname),
            });
            return true;
        }
        return false;
    }

    get headerbackgroundcolor() {
        return this._HeaderBackgroundColor || "#E8ECF2";
    }
    set headerbackgroundcolor(value) {
        this._HeaderBackgroundColor = value;
        value = this.tryToGetUserColor(value);
        this._tabs.style.backgroundColor = value;
        this._tabsContainer.style.backgroundColor = value;
    }

    // цвет background вкладки
    get tabbackgroundcolor() {
        return this._TabBackgroundColor;
    }
    set tabbackgroundcolor(value) {
        this._TabBackgroundColor = value;
        value = this.tryToGetUserColor(value);
        this._tabs.style.setProperty('--tab-background', value);
        this._updateActiveTabBackground(value)
    }

    _updateActiveTabBackground(rgbString) {
        const rgbValues = rgbString.match(/\d+/g).map(Number);
        const brightness = (rgbValues[0] * 299 + rgbValues[1] * 587 + rgbValues[2] * 114) / 1000;
        if (brightness > 5) {
            let factor;
            if (brightness > 50) {
                factor = 0.5;
            } else if (brightness > 30) {
                factor = 1.5;
            } else {
                factor = 3.0;
            }
            const newRed = Math.max(0, Math.min(255, rgbValues[0] * factor));
            const newGreen = Math.max(0, Math.min(255, rgbValues[1] * factor));
            const newBlue = Math.max(0, Math.min(255, rgbValues[2] * factor));
            this._tabs.style.setProperty('--tab-background-active', `rgb(${newRed}, ${newGreen}, ${newBlue})`);
        } else {
            this._tabs.style.setProperty('--tab-background-active', 'rgb(100,100,100)');
        }
    }

    // шрифт текста вкладки
    get tabfontfamily() {
        return this._tabfontfamily;
    }
    set tabfontfamily(value) {
        this._tabfontfamily = value;
        this._tabs.style.setProperty('--tab-font-family', value);
    }

    // размер текста вкладки
    get tabfontsize() {
        return this._tabfontsize;
    }
    set tabfontsize(value) {
        this._tabfontsize = value;
        this._tabs.style.setProperty('--tab-font-size', value);
    }

    // горизонтальное выравнивание текста вкладки
    get tabtextalign() {
        return this._tabtextalign;
    }
    set tabtextalign(value) {
        this._tabtextalign = value;
        switch (Number(value)) {
            case 0:
                this._tabs.style.setProperty('--tab-text-align', 'start');
                break;
            case 1:
                this._tabs.style.setProperty('--tab-text-align', 'center');
                break;
            case 2:
                this._tabs.style.setProperty('--tab-text-align', 'end');
                break;
        }
    }

    // курсивный текста вкладки
    get istabtextitalic() {
        return this._istabtextitalic;
    }
    set istabtextitalic(value) {
        this._istabtextitalic = value;
        if (this._toBool(value)) {
            this._tabs.style.setProperty('--tab-font-style', "italic");
        } else {
            this._tabs.style.setProperty('--tab-font-style', "normal");
        }
    }

    // жирный текст вкладки
    get istabfontweight() {
        return this._istabfontweight;
    }
    set istabfontweight(value) {
        this._istabfontweight = value;
        if (this._toBool(value)) {
            this._tabs.style.setProperty('--tab-font-weight', "bold");
        } else {
            this._tabs.style.setProperty('--tab-font-weight', "normal");
        }
    }

    // подчеркнутый текст вкладки
    get istabtextunderline() {
        return this._istabtextunderline;
    }
    set istabtextunderline(value) {
        this._istabtextunderline = value;
        if (this._toBool(value)) {
            this._tabs.style.setProperty('--tab-text-decoration', "underline");
        } else {
            this._tabs.style.setProperty('--tab-text-decoration', "none");
        }
    }

    // цвет текста вкладки
    get tabcolor() {
        return this._tabcolor;
    }
    set tabcolor(value) {
        this._tabcolor = value;
        this._tabs.style.setProperty('--tab-color', this.tryToGetUserColor(value));
    }

    get layout() {
        return this._layout;
    }
    set layout(value) {
        this._layout = value;
        const type = window._enums.LayoutType[value];
        switch (type) {
            case 0:
                this.style.flexDirection = "column";
                this._switchHorizontalPosition();
                if (this.heighttab !== undefined) this._tabs.style.setProperty('--tab-height', this.heighttab);
                if (this.widthtab !== undefined) this._tabs.style.setProperty('--tab-width', "fit-content");
                break;
            case 1:
                this.style.flexDirection = "column-reverse";
                this._switchHorizontalPosition();
                if (this.heighttab !== undefined) this._tabs.style.setProperty('--tab-height', this.heighttab);
                if (this.widthtab !== undefined) this._tabs.style.setProperty('--tab-width', "fit-content");
                break;
            case 2:
                this.style.flexDirection = "row";
                this._switchVerticalPosition();
                if (this.heighttab !== undefined) this._tabs.style.setProperty('--tab-height', 28);
                if (this.widthtab !== undefined) this._tabs.style.setProperty('--tab-width', this.widthtab);
                break;
            case 3:
                this.style.flexDirection = "row-reverse";
                this._switchVerticalPosition();
                if (this.heighttab !== undefined) this._tabs.style.setProperty('--tab-height', 28);
                if (this.widthtab !== undefined) this._tabs.style.setProperty('--tab-width', this.widthtab);
                break;
        }
    }

    _switchHorizontalPosition() {
        this._tabsContainer.classList.add("tabs__container__row")
        this._tabs.style.flexShrink = "0";
        this._tabs.classList.add("tabheader__row");
        this._tabs.classList.remove("tabheader__column");
        this._tabs.classList.remove("vertical-tabs");
        this._isRotated
            ? this._tabs.classList.add("btn-align")
            : this._tabs.classList.remove("btn-align");
    }

    _switchVerticalPosition() {
        this._tabsContainer.classList.remove("tabs__container__row")
        this._tabsContainer.classList.add("tabs__container__colmn")
        this._tabs.style.flexShrink = "";
        this._tabs.classList.remove("tabheader__row");
        this._tabs.classList.add("tabheader__column");
        if (this._isRotated) {
            this._tabs.classList.remove("btn-align");
            this._tabs.classList.add("vertical-tabs");
        } else {
            this._tabs.classList.add("btn-align");
        }
    }

    // высота вкладки
    get heighttab() {
        return this._heighttab;
    }
    set heighttab(value) {
        this._heighttab = value;
        if (this.layout === undefined) return
        if (this.layout > 1) {
            this._tabs.style.setProperty('--tab-height', 28);
        } else {
            this._tabs.style.setProperty('--tab-height', value);
        }
    }

    // ширина вкладки
    get widthtab() {
        return this._widthtab;
    }
    set widthtab(value) {
        this._widthtab = value;
        if (this.layout === undefined) return
        if (this.layout > 1) {
            this._tabs.style.setProperty('--tab-width', value);
        } else {
            this._tabs.style.setProperty('--tab-width', "fit-content");
        }
    }

    // перенос вкладок
    get movetabs() {
        return this._movetabs
    }

    set movetabs(value) {
        this._movetabs = value
        if (this._toBool(value)) {
            this._previousBtn.style.display = 'none'
            this._nextBtn.style.display = 'none'
            this._tabs.style.setProperty('--tabs-flex-wrap', "wrap");
        } else {
            this._previousBtn.style.display = ''
            this._nextBtn.style.display = ''
            this._tabs.style.setProperty('--tabs-flex-wrap', "nowrap");
        }
    }


    get orientation() {
        return this._orientation;
    }
    set orientation(value) {
        this._orientation = value;
        if (window._enums.OrientationType[value] == "row") {
            this._tabs.classList.remove("rotated");
            this._tabs.classList.remove("vertical-tabs");
            this._isRotated = false;
            switch (Number(this._layout)) {
                case 0:
                case 1:
                    this._tabs.classList.remove("btn-align");
                    break;
                case 2:
                case 3:
                    this._tabs.classList.add("btn-align");
                    break;
            }
        } else {
            this._tabs.classList.add("rotated");
            this._isRotated = true;
            switch (Number(this._layout)) {
                case 0:
                case 1:
                    this._tabs.classList.add("btn-align");
                    this._tabs.classList.remove("vertical-tabs");
                    break;
                case 2:
                case 3:
                    this._tabs.classList.remove("btn-align");
                    this._tabs.classList.add("vertical-tabs");
                    break;
            }
        }
    }

    get currenttab() {
        return this._currenttab;
    }
    set currenttab(v) {
        if (+v <= 0) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: String.format(i18next.t("paneltabcontrol_tab_not_found_title"), +v),
                text: String.format(i18next.t("paneltabcontrol_tab_not_found_text"), this._elname),
            });
            return;
        }

        if (typeof this._tabsDef === "undefined" || this._interaction) return;
        this.SelectTab(v);
    }

    get tabs() {
        return this._tabsDef;
    }
    set tabs(v) {
        try {
            this._tabsDef = JSON.parse(v);
        } catch (error) {
            this._tabsDef = [];
        }
        this._genTabs();
    }

    set isvisible(value) {
        this._showElement = this._toBool(value);
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._showElement;
        this.style.display = isShow ? "" : "none";
    }

    get resource() {
        return this._resource;
    }
    set resource(value) {
        this._resource = value;
    }

    setTabVisibility(tabId, isVisible) {
        const tab = this.tabsData.find(x => x.id === tabId);
        const isTabInitiated = !!tab;
        if (!isTabInitiated) {
            return;
        }

        if (isVisible) {
            if (!tab.isVisible) {
                const btn = Array.from(this._tabs.children).find(x => x.getAttribute("tabid") === tabId);
                btn.style.display = "block";
                this.refreshArrowState();

                const allTabsHidden = !this.tabsData.some(x => x.isVisible);
                tab.isVisible = isVisible;
                if (allTabsHidden) {
                    this.SelectTab(tab.tabNumber);
                }
            }
        } else {
            if (tab.isVisible) {
                const btn = Array.from(this._tabs.children).find(x => x.getAttribute("tabid") === tabId);
                btn.style.display = "none";
                this.refreshArrowState();

                tab.isVisible = isVisible;

                if (tab.tabNumber === this.currenttab) {
                    const newActiveTab = this.tabsData.find(x => x.isVisible);
                    if (newActiveTab) {
                        this.SelectTab(newActiveTab.tabNumber);
                    } else {
                        btn.classList.remove("active");
                        this._child.find(x => x.id == tabId).style.display = "none";
                        this._currenttab = 0; // напрямую пользователь не может задавать 0, но нам нужно обнулить, чтобы не было путаницы при открытии новой вкладки.
                    }
                }
            }
        }
    }

    afterInitialize() {
        if (!this._childBtn) {
            this._nextBtn.style.display = "none";
            this._previousBtn.style.display = "none";
        }
        if (!this._child) {
            return;
        }
        for (let i = 0; i < this._child.length; i++) {
            if (this._child[i].afterInitialize)
                this._child[i].afterInitialize();
        }
        this.isenabled = this.isenabled;
        this.raf = requestAnimationFrame(() => {
            if (!this._child) { // cancelAnimationFrame почему-то не отрабатывает, поэтому нужна эта проверка
                return;
            }
            for (let i = 0; i < this._child.length; i++) {
                const element = this._child[i];
                if (element.style.visibility === "hidden") {
                    element.style.display = "none";
                }
                element.style.visibility = "";
            }
        });
    }

    disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        super.disconnectedCallback();
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        if (attrName === "currenttab" && this.tabsData && this.hasWarning(newVal)) {
            return;
        }

        super.attributeChangedCallback(attrName, oldVal, newVal);
    }
}
